import React from 'react'

import { useAppContext } from './AppContext.jsx'
import { PageHeader, PageFooter, SectionContainer } from './PageCommon.jsx'

function ContentPage({ es, en }) {
    const { lang, getLanguageObject } = useAppContext();
    const t = getLanguageObject(lang, es, en);

    return (
        <>
            <PageHeader />
            <SectionContainer>
                <h1 className="section-title">{t.title}</h1>
                <div
                    style={{ whiteSpace: 'pre-wrap' }}
                    dangerouslySetInnerHTML={{ __html: t.content }}
                />
            </SectionContainer>
            <PageFooter />
        </>
    );
}

export default ContentPage
